.sn-testimonials-type-1 {
  display: contents;
}
